import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { SharedService } from 'app/modules/common/services/shared-service';

@Component({
    selector: 'app-employee-filter',
    templateUrl: './employee-filter.component.html',
    styleUrls: ['./employee-filter.component.scss'],
    standalone: false
})
export class EmployeeFilterComponent implements OnInit {

  public employeeFilter = new UntypedFormControl('',Validators.minLength(4));
  public employeeFilterString: string;

  constructor(private selectionGenericService: SelectionGenericService, private sharedService: SharedService) { }

  ngOnInit(): any {
  }

  public applyEmployeeFilter(): any {
    if (this.sharedService.selectedSelectionTabId === 1) {
        let isnum = /^\d+$/.test(this.employeeFilter.value); 
        if (!isnum) {
          this.employeeFilter.setValidators(Validators.minLength(4));
          this.employeeFilter.updateValueAndValidity();
        } 
        else if(isnum && (this.employeeFilter.value.length==1 || this.employeeFilter.value.length<4))
        {
          this.employeeFilter.setValidators(Validators.minLength(1));
          this.employeeFilter.updateValueAndValidity();
        }
        this.selectionGenericService.employeeSelectionModal.Trabajador = this.employeeFilter.value;
    }else if(this.sharedService.selectedSelectionTabId === 3) {
      let isnum = /^\d+$/.test(this.employeeFilter.value); 
        if (!isnum) {
          this.employeeFilter.setValidators(Validators.minLength(4));
          this.employeeFilter.updateValueAndValidity();
        } 
        else if(isnum && (this.employeeFilter.value.length==1 || this.employeeFilter.value.length<4))
        {
          this.employeeFilter.setValidators(Validators.minLength(1));
          this.employeeFilter.updateValueAndValidity();
        }
      this.selectionGenericService.ActuationSelectionModal.Trabajador = this.employeeFilter.value;
    }else {
      let isnum = /^\d+$/.test(this.employeeFilter.value); 
        if (!isnum) {
          this.employeeFilter.setValidators(Validators.minLength(4));
          this.employeeFilter.updateValueAndValidity();
        } 
        else if(isnum && (this.employeeFilter.value.length==1 || this.employeeFilter.value.length<4))
        {
          this.employeeFilter.setValidators(Validators.minLength(1));
          this.employeeFilter.updateValueAndValidity();
        }
      this.selectionGenericService.leaveSelectionModal.Trabajador = this.employeeFilter.value;
    }
    this.selectionGenericService.employeeFilter=this.employeeFilter;
  }

}
